import React from 'react';
import InlineFeedbackBase from './InlineFeedbackBase';

import TInlineFeedback from './types/TInlineFeedback';
import TEFeedbackSignal from '../../types/TEFeedbackSignal';

const Warning = ({ children, ...rest }: TInlineFeedback) => (
  <InlineFeedbackBase {...rest} signal={TEFeedbackSignal.Warning}>
    {children}
  </InlineFeedbackBase>
);

export default Warning;
